import script from "./ProfileModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileModal.vue?vue&type=script&setup=true&lang=js"

import "./ProfileModal.vue?vue&type=style&index=0&id=1f2979fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2979fb"]])

export default __exports__